// Déclenche la soumission du formulaire de la slide, comme le bouton « Valider et continuer » :
// validation de la slide, affichage des erreurs et tracking passent par le même chemin.
// Safari/iOS < 16 ne supporte pas requestSubmit() (cf. .claude/skills/ios15-safari-compat) :
// on retombe sur le click natif du bouton submit.
export const submitStepForm = (): boolean => {
  const form: HTMLFormElement | null = document.querySelector('#stepForm')
  const submitButton: HTMLButtonElement | null = document.querySelector(
    'button[type=submit][form=stepForm]',
  )
  if (!form || !submitButton) return false

  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit(submitButton)
  } else {
    submitButton.click()
  }
  return true
}
